import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ChevronLeft, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import { ULTIMAS } from "@/content/site";

const fmt = (iso) => {
    const [y, m, d] = iso.split("-").map(Number);
    return new Date(y, m - 1, d).toLocaleDateString("pt-BR", { day: "2-digit", month: "short", year: "numeric" });
};

const reduced = () => typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

// Faixa compacta com pesquisas aprovadas (status "publicado"); rotação calma a cada 8s.
const LatestResearchBar = () => {
    const { data } = useQuery({ queryKey: ["science-latest"], queryFn: async () => (await api.get("/science/latest")).data, staleTime: 60_000 });
    const [i, setI] = useState(0);
    const [paused, setPaused] = useState(false);
    const n = data?.length || 0;

    useEffect(() => {
        if (n < 2 || paused || reduced()) return;
        const t = setInterval(() => setI((v) => (v + 1) % n), 8000);
        return () => clearInterval(t);
    }, [n, paused]);

    if (!n) return null;
    const it = data[i % n];
    const go = (d) => setI((v) => (v + d + n) % n);

    return (
        <div data-testid="latest-research-bar" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} className="border-t border-[#1B3025] bg-[#0A1812]/95">
            <div className="max-w-7xl mx-auto px-6 md:px-10 h-10 flex items-center gap-4 text-[11.5px] font-sans">
                <span className="shrink-0 uppercase tracking-[0.26em] text-[10px] text-[#C7A659]">{ULTIMAS.label}</span>
                <span aria-hidden="true" className="hidden sm:block w-px h-4 bg-[#234135]" />
                <a
                    key={it.id}
                    href={it.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="latest-research-link"
                    aria-live="polite"
                    className="min-w-0 flex-1 truncate text-[#D7D1BF] hover:text-[#F2EFE5] transition-colors animate-fade-in"
                >
                    <span className="hidden md:inline text-[#7E8978]">{fmt(it.published_on)} · {it.venue}{it.source_type === "preprint" && !/preprint/i.test(it.venue) ? " (preprint)" : ""} · </span>
                    {it.short_title} <span aria-hidden="true" className="text-[#C7A659]">→</span>
                </a>
                {n > 1 && (
                    <div className="shrink-0 flex items-center gap-1">
                        <button type="button" data-testid="latest-research-prev" onClick={() => go(-1)} aria-label="Pesquisa anterior" className="p-1 text-[#7E8978] hover:text-[#F2EFE5]"><ChevronLeft size={15} /></button>
                        <span className="text-[10px] text-[#5A6859] tabular-nums">{(i % n) + 1}/{n}</span>
                        <button type="button" data-testid="latest-research-next" onClick={() => go(1)} aria-label="Próxima pesquisa" className="p-1 text-[#7E8978] hover:text-[#F2EFE5]"><ChevronRight size={15} /></button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LatestResearchBar;
